import React from "react"

export default class SelectTestCard extends React.Component {
  state = {
    testCardType: ""
  }

  handleSelectOnChange = event => {
    this.setState({ testCardType: event.target.value })
  }

  getTestCardNumber = card => {
    switch (card) {
      case "visa":
        return "4242 4242 4242 4242"
      case "visa-debit":
        return "4000 0566 5566 5556"
      case "mastercard":
        return "5555 5555 5555 4444"
      case "amex":
        return "3782 822463 10005"
      case "discover":
        return "6011 1111 1111 1117"
      default:
        return null
    }
  }

  render() {
    const { testCardType } = this.state

    const currentYear = parseInt(
      new Date()
        .getFullYear()
        .toString()
        .substr(-2),
      10
    )

    return (
      <div>
        <div className="alert info-alert" css={{ paddingTop: 40, marginTop: -48 }}>
          <div className="d-f fd-cr fd-r@sm ai-fs ai-c@sm">
            <div className="w-100% w-a@sm">
              <select className="select" css={{ height: 32 }} onChange={this.handleSelectOnChange}>
                <option value="">Select a test card:</option>
                <option value="visa">Visa</option>
                <option value="visa-debit">Visa (debit)</option>
                <option value="mastercard">Mastercard</option>
                <option value="amex">American Express</option>
                <option value="discover">Discover</option>
              </select>
            </div>

            <div className="d-ib ml-1">(This account is in test mode)</div>
          </div>

          {testCardType !== "" && (
            <div className="px-4p pt-2 d-f jc-sb">
              <div className="d-if ai-c jc-fs">
                <span className="fw-400 fs-5 pr-4p">USE:</span>
                <span className="fw-600">{this.getTestCardNumber(testCardType)}</span>
              </div>
              <div className="fw-600">
                <span>01/{currentYear + 5}</span>

                <span
                  css={{
                    marginRight: testCardType === "amex" ? "0.5em" : ".75em",
                    marginLeft: testCardType === "amex" ? "1.25em" : "1.5em"
                  }}
                >
                  {testCardType === "amex" ? "1234" : "222"}
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
}
